import { IVacancy, IVacancyListItem, VacancyResponseType } from "./vacancy.types";

export default class Vacancy implements  IVacancy {
    total: number;
    data: IVacancyListItem[] = [];
    constructor(data: VacancyResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}